// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-box[data-v-4f60b156]{margin-top:60px}.bottom-bar[data-v-4f60b156]{background-color:#4abca5;border-top-style:solid;border-top-color:#837d89;border-top-width:5px}", ""]);
// Exports
module.exports = exports;
